  <!-- 油卡档案 -->
  <template>
  <div>
    <!-- 按钮列表 -->
    <butotn-plug :btndata="BTN_CONFIG" @btnEvent="callBack" @clearBtns="clearBtns" @moreParam="moreParam" @queryBtn_ok="queryBtn_ok" ref="btnList" />
    <!-- 查询列表 -->
    <input-plug ref="queryForm" :form-config="baseConfig" :form-data="queryData" :More="isHaseMore" />
    <!-- 表格 -->
    <table-plug :tableConfig="tableConfig" :defaulthead="myTableHeard" :totals="totalArr" @rowCallback="rowCallback" @selectChange="handleSelectionChange" @jumpPage="goYdDetails" ref="mytable" />
    <!-- 分页 -->
    <paging ref="pags" :pageNum="pageStart" :total="pageCount" :size="pageTotal" @handleSizeChange="handleSizeChange" @handleCurrentChange="handleCurrentChange" />
    <!--        自定义表头           -->
    <sorttable
      :show_sortTableHeard="show_sortTableHeard"
      :allCheck="allCheck"
      :sortName="sortName"
      :tabelHeadeTitle="tabelHeadeTitle"
      :originalTabelHeadeTitle="originalTabelHeadeTitle"
      :selectLength="selectLength"
      @cancelSortHeard="cancelSortHeard"
      @confirmOk="confirmOk"
      @checktab="checktab"
      @checkAll="checkAll"
      @closeDias="closeDias"
    />

    <!-- 新增弹窗 -->
    <my-dialog :diaWidth="diaWidth" :dialogTitle="dialogTitle" :isShowDialog="isShowDialog" @handleCloseDia="handleCloseDia" @diaCancelBtn="diaCancelBtn" @diaConfirmBtn="diaConfirmBtn">
      <dia-form :diaFormConfig="diaFormConfig" ref="diaform" :rules="formRules" :baseModel="baseModel" :Reset="isShowDialog" @changeCallback="changeCallback" />
    </my-dialog>
    <!-- 导出插件 -->
    <exportCompoent
      :isShowDialog_dc="isShowDialog_dc"
      :diaWidth_dc="diaWidth_dc"
      :dialogTitle_dc="dialogTitle_dc"
      :dialogForm_dc="dialogForm_dc"
      :tableHeard="EPtableHeard"
      :AllCheck="EPAllCheck"
      @checktabEP="checktabEP"
      @checkAllEP="checkAllEP"
      @onAfterEnter="onAfterEnter"
      @handleCloseDia_dc="handleCloseDia_dc"
      @diaConfirmBtn_dc="diaConfirmBtn_dc()"
    >
      <!-- 查询列表 -->
      <input-plug ref="queryForm" :form-config="baseConfig" :form-data="queryData" :More="true" />
    </exportCompoent>
  </div>
</template>
    <script >
import { mixin_1 } from "@/assets/js/Mixins/mixin";
import sorttable from "@/components/sortTemplate.vue"; //自定义排序表头
import ButotnPlug from "@/components/Modules/ButtonPlug.vue";
import InputPlug from "@/components/Modules/InputPlug.vue";
import multitime from "@/components/multiTime.vue";
import paging from "@/components/pagings.vue"; //分页组件
import TablePlug from "@/components/Modules/TablePlug.vue";
import MyDialog from "@/components/Dialog.vue";
import DiaForm from "@/pages/VMS/VMSConpon/DiaForm.vue";
import exportjs from "@/assets/js/Mixins/export.js"; //导出的公共js
export default {
  mixins: [mixin_1,exportjs],
  components: {
    ButotnPlug,
    InputPlug,
    multitime,
    TablePlug,
    paging,
    sorttable,
    MyDialog,
    DiaForm,
  },
  data() {
    return {
      //=======================导出相关 开始 =======================
      dialogForm_dc: {
        pageStart: 1,
        pageTotal: "",
        fileName: "油卡档案", //导出时默认文件名
        apiName: "/admin/v3/tms/car/oil/OilCardd/getOilCardList", //导出的数据列表接口名(动态列表都是这个)
        EpType: "bdd", //dd==等待下载完成,bdd==不等待完成
        apiType: "GET", //导出当前列表的请求方式
        isJson: 1, // 导出当前列表的请求头是否json
      },
      //=======================导出相关 结束 =======================
      // 按钮配置
      BTN_CONFIG: [
        {
          name: "新增",
          method: "addClick",
          permissVal: "admin:oil_card:addOilCard",
        },
        {
          name: "修改",
          method: "modifyClick",
          permissVal: "admin:oil_card:udpateOilCard",
        },
        {
          name: "删除",
          method: "delete",
          permissVal: "admin:oil_card:delOilCard",
        },
        {
          name: "启用",
          method: "startUsing",
          permissVal: "admin:oil_card:startOilCard",
        },
        {
          name: "禁用",
          method: "Disable",
          permissVal: "admin:oil_card:stopOilCard",
        },
        {
          name: "表格设置",
          method: "SetTable",
          permissVal: "aaaaa",
        },
        {
          name: "导出",
          method: "ExportData",
          permissVal: "aaaaa",
        },
      ],
      // 更多搜索
      isHaseMore: false,
      //  查询框
      baseConfig: [
        {
          type: "input",
          label: "卡号",
          field: "oilCardNumber",
          placeholder: "请输入",
        },
        {
          type: "input",
          label: "归属车牌",
          field: "carNumber",
          placeholder: "请输入",
        },
        {
          type: "input",
          label: "油站名称",
          field: "oilStationName",
          placeholder: "请输入",
        },
      ],

      queryData: {
        carNumber: "",
        oilCardNumber: "",
        oilStationName: "",
      },

      // 表格配置
      tableConfig: {
        tableHeigth: "75vh",
        tableData: [],
      },
      className: "", //  导出需要
      pageGroupName: "GasArchive", //  页面标识
      myTableHeard: [],
      tabelHeadeTitle: [
        {
          name: "操作",
          field: "edit",
          width: 220,
          Buttons: [
            {
              method: "modifyClick",
              methodName: "修改",
              permissVal: "admin:oil_card:udpateOilCard",
            },
            {
              method: "delete",
              methodName: "删除",
              permissVal: "admin:oil_card:delOilCard",
            },
            {
              method: "startUsing",
              methodName: "启用",
              permissVal: "admin:oil_card:startOilCard",
            },
            {
              method: "Disable",
              methodName: "禁用",
              permissVal: "admin:oil_card:stopOilCard",
            },
          ],
        },
        {
          name: "卡号",
          field: "oilCardNumber",
          width: "120",
          sort: 3,
          isShow: true, //是否展示
          isTotal: true, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "余额",
          field: "balance",
          sort: 4,
          isShow: true,
          isTotal: false,
          isSort: true,
        },

        {
          name: "开卡日期",
          field: "openCardDate",
          sort: 5,
          isShow: true,
          isSort: true,
        },
        {
          name: "有效日期",
          field: "effectiveDate",
          sort: 6,
          isShow: true,
          isSort: true,
        },
        {
          name: "启用状态",
          field: "cardStatusShow",
          sort: 1,
          isShow: true,
        },
        {
          name: "开卡人",
          field: "openCardUserName",
          sort: 1,
          isShow: true,
        },
        {
          name: "是否主卡",
          field: "isMainCardShow",
          sort: 1,
          isShow: true,
        },
        {
          name: "归属车牌",
          field: "carNumber",
          sort: 1,
          isShow: true,
        },
        {
          name: "归属主卡号",
          field: "parentOilCardNumber",
          sort: 1,
          isShow: true,
        },
        {
          name: "油站名称",
          field: "oilStationName",
          sort: 18,
          isShow: true,
        },
        {
          name: "油站地址",
          field: "oilStationAddress",
          sort: 19,
          isShow: true,
        },
        {
          name: "备注",
          field: "remarks",
          sort: 1,
          isShow: true,
        },
      ],
      sortName: "油卡档案", //  排序名
      //   车辆弹窗
      diaWidth: "60%",
      dialogTitle: "油卡档案",
      isShowDialog: false,
      diaFormConfig: [
        {
          gutter: 0,
          formItem: [
            {
              span: 8,
              title: "是否主卡",
              itemType: "select",
              field: "isMainCard",
              placeholder: "请选择",
              disabled: false,
              selectChange: "isMainCardChange",
              options: [
                {
                  label: "是",
                  val: 1,
                },
                {
                  label: "否",
                  val: 0,
                },
              ],
            },
            {
              span: 8,
              title: "归属主卡",
              itemType: "selectloadmore",
              field: "parentOilCardId",
              loadmoreMethod: "loadoilCard",
              remotemethod: "remoteoilCard",
              loading: false,
              setLabel: "oilCardNumber",
              setValue: "oilCardId",
              disabled: false,
              placeholder: "输入卡号进行匹配",
              options: [],
            },
            {
              span: 8,
              title: "归属部门",
              itemType: "selectloadmore",
              field: "deptId",
              loadmoreMethod: "loadDept",
              remotemethod: "remoteDept",
              loading: false,
              setLabel: "departmentName",
              setValue: "deptId",
              placeholder: "输入部门进行匹配",
              options: [],
            },
          ],
        },
        {
          gutter: 0,
          formItem: [
            {
              span: 8,
              title: "卡号",
              itemType: "input",
              field: "oilCardNumber",
              placeholder: "请输入",
            },
            {
              span: 8,
              title: "余额",
              itemType: "input",
              field: "balance",
              placeholder: "请输入",
            },
            {
              span: 8,
              title: "开卡日期",
              itemType: "datetime",
              field: "openCardDate",
              placeholder: "请选择",
            },
          ],
        },
        {
          gutter: 0,
          formItem: [
            {
              span: 8,
              title: "有效日期",
              itemType: "datetime",
              field: "effectiveDate",
              placeholder: "请选择",
            },
            {
              span: 8,
              title: "开卡人",
              itemType: "input",
              field: "openCardUserName",
              placeholder: "请输入",
            },
            {
              span: 8,
              title: "归属车牌",
              itemType: "selectloadmore",
              field: "carNumber",
              loadmoreMethod: "loadCarplate",
              remotemethod: "remoteCarplate",
              loading: false,
              setLabel: "carNumber",
              setValue: "carNumber",
              placeholder: "输入车牌号进行匹配",
              options: [],
            },
          ],
        },
        {
          gutter: 0,
          formItem: [
            {
              span: 8,
              title: "油站名称",
              itemType: "input",
              field: "oilStationName",
              placeholder: "请输入",
            },
            {
              span: 16,
              title: "油站地址",
              itemType: "input",
              field: "oilStationAddress",
              placeholder: "请输入",
            },
          ],
        },
        {
          gutter: 0,
          formItem: [
            {
              span: 24,
              title: "备注",
              itemType: "textarea",
              field: "remarks",
              placeholder: "请输入",
            },
          ],
        },
      ],
      formRules: {
        // carNumber: [
        //   { required: true, message: "请选择归属车牌号", trigger: "change" },
        // ],
        // carNumber: [
        //   { required: true, message: "请选择归属车牌号", trigger: "change" },
        // ],
        openCardUserName: [
          { required: true, message: "请选择", trigger: "change" },
        ],
        deptId: [
          { required: true, message: "请选择归属部门", trigger: "change" },
        ],
        isMainCard: [{ required: true, message: "请输入", trigger: "blur" }],
        oilCardNumber: [
          { required: true, message: "请输入有效油卡号", trigger: "blur" },
        ],
      },
      baseModel: {},
      defaultBaseModel: {
        carNumber: null,
        deptId: null,
        isMainCard: null,
        oilCardNumber: null,
        balance: null,
        effectiveDate: null,
        oilStationAddress: null,
        oilStationName: null,
        openCardDate: null,
        openCardUserName: null,
        parentOilCardId: null,
        remarks: null,
      },
      DeptPage: {
        pageStart: 1,
        pageTotal: 20,
        pageCount: 0,
      },
      oilCardPage: {
        pageStart: 1,
        pageTotal: 20,
        pageCount: 0,
      },
      CarNumberPage: {
        pageStart: 1,
        pageTotal: 20,
        pageCount: 0,
      },
    };
  },
  updated() {
    if (this.show_sortTableHeard) {
      // 排序表头
      let arr = this.tabelHeadeTitle;
      for (var i = 0; i < arr.length; i++) {
        arr[i].sort = i + 1;
      }
      this.tabelHeadeTitle = arr;
    }
  },
  created() {
    this.defaultFormfield = this.baseModel;
    this.GetData();
    // this.GetObjectUserDownList("dept");
    this.Getdept();
    this.GetOilCardDownList();
    this.GetCarDownList();
  },
  methods: {
    // 获取油卡档案列表
    GetData() {
      this.queryData.pageStart = this.pageStart;
      this.queryData.pageTotal = this.pageTotal;
      this.$API.OilCardList(this.queryData).then((res) => {
        if (res.data.status === "success") {
          this.className = res.data.result.className || "";
          this.tableConfig.tableData = res.data.result?.data || [];
          this.pageCount = res.data.result.pageCount || 0;
          this.$nextTick(() => {
            this.fetTableHeight();
          });
        } else {
          this.$message.error(`${res.data.message}---油卡档案列表`);
        }
      });
    },

    // 获取归属部门
    Getdept(e, checkedData) {
      let query = {
        pageStart: this.DeptPage.pageStart,
        pageTotal: this.DeptPage.pageTotal,
        deptName: e,
        deptId: checkedData,
      };
      this.$API
        .wtl_getDeptList(query)
        .then((res) => {
          this.diaFormConfig[0].formItem[2].loading = false;
          if (res.data.status === "success") {
            let result = res.data.result?.data || [];
            let arr = this.diaFormConfig[0].formItem[2].options;
            if (e) {
              this.diaFormConfig[0].formItem[2].options = result;
            } else {
              this.diaFormConfig[0].formItem[2].options = [
                ...arr,
                ...result.filter(
                  (item) => !arr.some((x) => x.deptId === item.deptId)
                ),
              ];
            }
            if (!e && !checkedData) {
              this.DeptPage.pageCount = res.data.result?.pageCount || 0;
            }
          }
        })
        .catch((catchres) => {
          this.diaFormConfig[0].formItem[2].loading = false;
        });
    },
    // 部门远程搜索
    remoteDept(e) {
      // 当输入框有关键字的时候，loading为true显示加载圈圈，请求对应关键字数据
      this.DeptPage.pageStart = 1;
      if (e !== "") {
        this.diaFormConfig[0].formItem[2].loading = true;
        this.Getdept(e);
      } else {
        this.Getdept();
      }
    },

    loadDept() {
      let count = this.DeptPage.pageCount / this.DeptPage.pageTotal;
      if (count > this.DeptPage.pageStart) {
        this.diaFormConfig[0].formItem[2].loading = true;
        this.DeptPage.pageStart += 1;
        this.Getdept();
      } else {
        console.log("数据已全部加载");
      }
    },

    // 获取归属主卡
    GetOilCardDownList(e, checkedData) {
      let query = {
        pageStart: this.oilCardPage.pageStart,
        pageTotal: this.oilCardPage.pageTotal,
        oilCardNumber: e,
        oilCardId: checkedData,
      };
      this.$API
        .OilCardDownList(query)
        .then((res) => {
          if (res.data.status === "success") {
            let data = res.data.result?.data || [];
            let arr = this.diaFormConfig[0].formItem[1].options;
            let result = [];
            for (let i in data) {
              if (data[i].isMainCard) {
                result.push(data[i]);
              }
            }
            if (e) {
              this.diaFormConfig[0].formItem[1].options = result;
            } else {
              this.diaFormConfig[0].formItem[1].options = [
                ...arr,
                ...result.filter(
                  (item) => !arr.some((x) => x.oilCardId === item.oilCardId)
                ),
              ];
            }
            if (!e && !checkedData) {
              this.oilCardPage.pageCount = res.data.result?.pageCount || 0;
            }
            // this.diaFormConfig[0].formItem[1].options = result;
          }
        })
        .catch((catchres) => {
          this.diaFormConfig[0].formItem[1].loading = false;
        });
    },
    // 归属卡号远程搜索
    remoteoilCard(e) {
      this.oilCardPage.pageStart = 1;
      if (e !== "") {
        this.diaFormConfig[0].formItem[1].loading = true;
        this.GetOilCardDownList(e);
      } else {
        this.GetOilCardDownList();
      }
    },
    loadoilCard() {
      let count = this.oilCardPage.pageCount / this.oilCardPage.pageTotal;
      if (count > this.oilCardPage.pageStart) {
        this.diaFormConfig[0].formItem[1].loading = true;
        this.oilCardPage.pageStart += 1;
        this.GetOilCardDownList();
      } else {
        console.log("数据已全部加载");
      }
    },
    // 获取弹窗车牌
    GetCarDownList(e, checkedData) {
      let query = {
        pageStart: this.CarNumberPage.pageStart,
        pageTotal: this.CarNumberPage.pageTotal,
        carNumber: e,
        carId: checkedData,
      };
      this.$API
        .CarDownList(query)
        .then((res) => {
          this.diaFormConfig[2].formItem[2].loading = false;
          if (res.data.status === "success") {
            let result = res.data.result?.data || [];
            let arr = this.diaFormConfig[2].formItem[2].options;
            if (e) {
              this.diaFormConfig[2].formItem[2].options = result;
            } else {
              this.diaFormConfig[2].formItem[2].options = [
                ...arr,
                ...result.filter(
                  (item) => !arr.some((x) => x.carId === item.carId)
                ),
              ];
            }
            if (!e && !checkedData) {
              this.CarNumberPage.CarNumberPage =
                res.data.result?.pageCount || 0;
            }
          }
        })
        .catch((catchres) => {
          this.diaFormConfig[2].formItem[2].loading = false;
        });
    },
    // 归属车牌远程搜索
    remoteCarplate(e) {
      this.CarNumberPage.pageStart = 1;
      if (e !== "") {
        this.diaFormConfig[2].formItem[2].loading = true;
        this.GetCarDownList(e);
      } else {
        this.GetCarDownList();
      }
    },
    // 归属车牌加载更多
    loadCarplate() {
      let count = this.CarNumberPage.pageCount / this.CarNumberPage.pageTotal;
      if (count > this.CarNumberPage.pageStart) {
        this.diaFormConfig[2].formItem[2].loading = true;
        this.CarNumberPage.pageStart += 1;
        this.GetCarDownList();
      } else {
        console.log("数据已全部加载");
      }
    },
    // 表格内按钮的回调事件
    rowCallback(data, name) {
      this[name](data);
    },
    changeCallback(VAL, NAME) {
      this[NAME](VAL);
    },
    isMainCardChange(DATA) {
      this.diaFormConfig[0].formItem[1].disabled = Boolean(DATA);
    },
    // 表格设置
    SetTable() {
      this.$TOOLS.myModel(this);
    },
    // 导出
    ExportData() {
      // this.$COMAPI.exportBtn({
      //   pageGroupName: this.pageGroupName, //页面标识
      //   myTableHeard: this.myTableHeard, //表头数组
      //   className: this.className, //列表标识
      //   tableData: this.tableConfig.tableData, //数据源
      //   sheetName: "表名(暂无效)", //表名
      // });
      this.isShowDialog_dc = true;
    },
    // 新增
    addClick() {
      this.diaFormConfig[0].formItem[0].disabled = false;
      this.isShowDialog = true;
    },
    // 修改
    modifyClick(data) {
      if (data) this.selectTableData = [data];
      if (this.selectTableData.length !== 1) {
        this.$message.error("请选择一条数据进行操作");
        return false;
      } else {
        this.isShowDialog = true;
        this.baseModel = this.selectTableData[0];
        this.diaFormConfig[0].formItem[1].disabled = Boolean(
          this.baseModel.isMainCard
        );
        this.diaFormConfig[0].formItem[0].disabled = true;
      }
    },
    // 删除
    delete(data) {
      if (data) this.selectTableData = [data];
      if (this.selectTableData.length < 1) {
        this.$message.error("请至少选择一条数据进行操作");
        return false;
      } else {
        this.$confirm("确定要删除所选数据吗?", "提示:")
          .then((res) => {
            let delReq = {
              oilCardIds: new Array(),
            };
            this.selectTableData.map(function (val, i) {
              delReq.oilCardIds.push(val.oilCardId);
            });
            this.$API.delOilCard(delReq).then((res) => {
              if (res.data.status === "success") {
                try {
                  let num = 0;
                  let arr = this.tableConfig.tableData;
                  if (delReq.oilCardIds.length > 2) {
                    delReq.oilCardIds.map(function (v, i) {
                      num = arr.findIndex((element) => element.oilCardId == v);
                      arr.splice(num, 1);
                    });
                  } else {
                    num = arr.findIndex(
                      (element) => element.oilCardId == delReq.oilCardIds[0]
                    );
                    arr.splice(num, 1);
                  }
                } catch {
                  this.GetData();
                }
                this.$message.success("已删除");
              }
            });
          })
          .catch((err) => {
            if (data) this.selectTableData.length = 0;
          });
      }
    },
    // 启用
    startUsing(data, t) {
      if (data) this.selectTableData = [data];
      let msg = "启用";
      if (t) msg = t;
      if (this.selectTableData.length < 1) {
        this.$message.error("请至少选择一条数据进行操作");
        return false;
      } else {
        this.$confirm(`确认${msg}所选数据?`, "提示:")
          .then((res) => {
            let params = {
              oilCardIds: new Array(),
            };
            this.selectTableData.map(function (val, i) {
              params.oilCardIds.push(val.oilCardId);
            });

            if (t) {
              // 禁用接口
              this.$API.stopOilCard(params).then((r) => {
                if (r.data.status === "success") {
                  this.GetData();
                  this.$message.success(`已${msg}`);
                }
              });
            } else {
              // 启用接口
              this.$API.startOilCard(params).then((e) => {
                if (e.data.status === "success") {
                  this.GetData();
                  this.$message.success(`已${msg}`);
                }
              });
            }
          })
          .catch((err) => {
            if (data) this.selectTableData.length = 0;
          });
      }
    },
    // 禁用
    Disable(data) {
      this.startUsing(data, "禁用");
    },

    // 更多搜索
    moreParam(e) {
      this.isHaseMore = e;
      this.$nextTick(() => {
        this.fetTableHeight();
      });
    },
    // 查询事件
    queryBtn_ok() {
      this.GetData();
    },
    // 清空查询
    clearBtns() {
      this.$refs["queryForm"].$refs.forms.resetFields();
      this.GetData();
    },

    // // 表格选择事件
    handleSelectionChange(e) {
      this.selectTableData = e;
    },
    // 跳转运单详情
    goYdDetails(a) {
      this.$message.success("你点我干嘛");
    },

    //  弹窗确认保存事件
    diaConfirmBtn() {
      this.$refs["diaform"].$refs.addForm.validate((valid) => {
        if (valid) {
          // 正常提交
          let param = {};
          for (let key in this.defaultBaseModel) {
            if (this.baseModel[key] || this.baseModel[key] == 0) {
              eval("param." + key + "='" + this.baseModel[key] + "'");
            } else {
              eval("param." + key + "=''");
            }
          }
          if (this.baseModel.oilCardId)
            param.oilCardId = this.baseModel.oilCardId;
          if (param.oilCardId) {
            // 修改接口
            this.$API.udpateOilCard(param).then((res) => {
              if (res.data.status === "success") {
                this.$message.success(res.data.message);
                this.isShowDialog = false;
                this.GetData();
              }
            });
          } else {
            // 新增接口
            this.$API.addOilCard(param).then((res) => {
              if (res.data.status === "success") {
                this.$message.success(res.data.message);
                this.isShowDialog = false;
                this.GetData();
              }
            });
          }
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    //  弹窗关闭事件(左上角的x和关闭按钮都算)
    handleCloseDia() {
      this.baseModel = {
        carNumber: null,
        deptId: null,
        isMainCard: null,
        oilCardNumber: null,
        balance: null,
        effectiveDate: null,
        oilStationAddress: null,
        oilStationName: null,
        openCardDate: null,
        openCardUserName: null,
        parentOilCardId: null,
        remarks: null,
      };
      this.selectTableData.length = 0;
      this.$refs.mytable.$refs.tables.clearSelection();
      this.isShowDialog = false;
    },

    //  关闭弹窗按钮事件(关闭按钮)
    diaCancelBtn() {
      this.handleCloseDia();
    },
  },
};
</script>
    <style scoped lang="less">
</style>
    